import aiCredits from './ai-credits.json'
import aiChat from './ai-chat.json'
import auth from './auth.json'
import billing from './billing.json'
import brands from './brands.json'
import categories from './categories.json'
import checkout from './checkout.json'
import common from './common.json'
import countries from './countries.json'
import customers from './customers.json'
import dashboard from './dashboard.json'
import discounts from './discounts.json'
import errors from './errors.json'
import legalPages from './legal-pages.json'
import merchants from './merchants.json'
import nav from './nav.json'
import onboarding from './onboarding.json'
import orders from './orders.json'
import pageBuilder from './page-builder.json'
import products from './products.json'
import roles from './roles.json'
import seo from './seo.json'
import settings from './settings.json'
import shipping from './shipping.json'
import smartCollections from './smart-collections.json'
import stores from './stores.json'
import subscriptionPlans from './subscription-plans.json'
import subscriptions from './subscriptions.json'
import users from './users.json'
import validation from './validation.json'

export default {
  aiCredits,
  aiChat,
  billing,
  common,
  auth,
  nav,
  dashboard,
  users,
  roles,
  settings,
  validation,
  errors,
  legalPages,
  merchants,
  countries,
  onboarding,
  ...pageBuilder,
  stores,
  subscriptionPlans,
  subscriptions,
  products,
  categories,
  brands,
  seo,
  customers,
  shipping,
  smartCollections,
  discounts,
  orders,
  checkout,
}
